import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useMaps } from "@miplatform/hooks";

export const useAddCityViewModel = ({ edit, onCreate }) => {
  const stateManager = useComponentState();
  const isLoading = stateManager.isBusy();
  const { getCounty } = useMaps();

  const addCity = async (values = {}) => {
    const {
      city,
      regionCode,
      county,
      isValid = true,
      countryCode = "USA",
      timeZone,
    } = values;
    let countyName = county;

    try {
      if (!county) {
        countyName = (await getCounty(city, regionCode)) || city;
      }
    } catch {
      countyName = city;
    }

    stateManager.run(async () => {
      const response = await homeService.cities.create({
        data: {
          regionCode,
          countyName,
          cityName: city,
          isValid,
          countryCode,
          timeZone,
        },
      });

      if (response.status === HTTP_STATUSES.OK && onCreate) {
        onCreate(response.data);
        edit.reset();
      }
    });
  };

  return {
    isLoading,
    addCity,
  };
};
